import { Serializable } from "@/core/api/decorators/serializable_decorator"
import { LeadTaskType } from "@/modules/lead/constants/leadTaskType"
import { LeadResponsibleModel } from "@/modules/lead/models/leadResponsibleModel"

@Serializable
export class LeadReviewTaskListView {
  uid: string = ""
  name: string = ""
  role: string = ""
  customerId: string = ""
  customerName: string = ""
  customerDeadline: string = ""
  taskType: number = LeadTaskType.NotDefined
  numFiles: number = 0
  numNotes: number = 0
  numRequirements: number = 0
  status: number = 0
  responsibles: LeadResponsibleModel[] = []

  constructor(
    data: {
      uid: string
      name: string
      role: string
      customerId: string
      customerName: string
      customerDeadline: string
      taskType: number
      numFiles: number
      numNotes: number
      numRequirements: number
      status: number
      responsibles: any[]
    } | null = null,
  ) {
    if (data) {
      this.uid = data.uid
      this.name = data.name
      this.role = data.role
      this.customerId = data.customerId
      this.customerName = data.customerName
      this.customerDeadline = data.customerDeadline
      this.taskType = data.taskType
      this.numFiles = data.numFiles
      this.numNotes = data.numNotes
      this.numRequirements = data.numRequirements
      this.status = data.status
      this.responsibles = data.responsibles
    }
  }
}
